<template>
  <rh-etapa-card
    titulo="Endereço Residencial"
    subtitulo="CEP, logradouro e complemento"
    icone="mdi-map-marker"
  >
    <v-row>
      <v-col cols="12" md="3" class="pt-0 pb-0">
        <e-label>CEP</e-label>
        <v-text-field
          v-mask="'#####-###'"
          v-model="form.pessoal.cep"
          dense
          solo
          :loading="buscandoCep"
          hint="O endereço é preenchido automaticamente"
        />
      </v-col>

      <v-col cols="12" md="2" class="pt-0 pb-0">
        <e-label>Estado (UF)</e-label>
        <v-autocomplete
          :items="$constants.estadosList"
          :return-object="false"
          :item-text="(item) => item.codigo"
          :item-value="(item) => item.codigo"
          v-model="form.pessoal.uf_residencia"
          label="Selecione"
          dense
          solo
        />
      </v-col>

      <v-col cols="12" md="7" class="pt-0 pb-0">
        <e-label>Cidade</e-label>
        <v-text-field v-model="form.pessoal.municipio_residencia" dense solo />
      </v-col>

      <v-col cols="12" md="4" class="pt-0 pb-0">
        <e-label>Bairro</e-label>
        <v-text-field v-model="form.pessoal.bairro_residencia" dense solo />
      </v-col>

      <v-col cols="12" md="4" class="pt-0 pb-0">
        <e-label>Rua</e-label>
        <v-text-field v-model="form.pessoal.rua_residencia" dense solo />
      </v-col>

      <v-col cols="12" md="2" class="pt-0 pb-0">
        <e-label>Número</e-label>
        <v-text-field v-model="form.pessoal.numero_residencia" dense solo v-mask="'########'" />
      </v-col>

      <v-col cols="12" md="2" class="pt-0 pb-0">
        <e-label>Complemento</e-label>
        <v-text-field v-model="form.pessoal.complemento_residencia" dense solo />
      </v-col>
    </v-row>

    <rh-documentos-secao
      categoria="endereco"
      titulo="Comprovante de residência"
      subtitulo="Ex.: conta de água, luz ou contrato de aluguel."
      :itens="documentos"
      v-on="$listeners"
    />
  </rh-etapa-card>
</template>

<script>
import RhEtapaCard from "../components/RhEtapaCard.vue";
import RhDocumentosSecao from "../components/RhDocumentosSecao.vue";

export default {
  name: "EtapaEndereco",
  components: { RhEtapaCard, RhDocumentosSecao },
  props: {
    form: { type: Object, required: true },
    documentos: { type: Array, default: () => [] },
  },
  data() {
    return {
      buscandoCep: false,
    };
  },
  watch: {
    "form.pessoal.cep": function (newVal) {
      const cleanCep = (newVal || "").replace(/\D/g, "");
      if (cleanCep.length === 8) {
        this.buscarEnderecoPorCep(cleanCep);
      }
    },
  },
  methods: {
    async buscarEnderecoPorCep(cepString) {
      this.buscandoCep = true;
      try {
        const res = await this.$services.cepService.buscarCepNoBack(cepString);
        if (res) {
          this.form.pessoal.uf_residencia = res.estado || "";
          this.form.pessoal.municipio_residencia = res.cidade || "";
          this.form.pessoal.bairro_residencia = res.bairro || "";
          this.form.pessoal.rua_residencia = res.rua || "";
        }
      } catch (error) {
        this.$toast.danger("CEP não encontrado ou erro na busca");
      } finally {
        this.buscandoCep = false;
      }
    },
  },
};
</script>
